// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vz_a bhf_b"};